export const BEFORE_ARRIVAL = 'BEFORE_ARRIVAL';
export const UPON_ARRIVAL = 'UPON_ARRIVAL';
export const OPTIONAL = 'OPTIONAL';
